import { render, staticRenderFns } from "./NewsReport.vue?vue&type=template&id=e485b53a&scoped=true"
import script from "./NewsReport.vue?vue&type=script&lang=js"
export * from "./NewsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.30_cache-loader@4.1.0_webpack@4.46.0__css-load_ecc709542230bcceb67dd6366ef941ae/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e485b53a",
  null
  
)

export default component.exports